"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableCountries = exports.getCountriesList = exports.getCountriesOptions = void 0;
const countries_de_with_country_code_json_1 = __importDefault(require("./data/countries-de-with-country-code.json"));
const countries_en_with_country_code_json_1 = __importDefault(require("./data/countries-en-with-country-code.json"));
const countries_es_with_country_code_json_1 = __importDefault(require("./data/countries-es-with-country-code.json"));
const countries_fr_with_country_code_json_1 = __importDefault(require("./data/countries-fr-with-country-code.json"));
const countries_pt_with_country_code_json_1 = __importDefault(require("./data/countries-pt-with-country-code.json"));
const countriesMap = {
    de: countries_de_with_country_code_json_1.default,
    en: countries_en_with_country_code_json_1.default,
    es: countries_es_with_country_code_json_1.default,
    fr: countries_fr_with_country_code_json_1.default,
    pt: countries_pt_with_country_code_json_1.default,
};
const computeOptions = (countries) => {
    return countries.map((country) => ({
        value: country.alpha2,
        text: country.label,
        label: country.label,
    }));
};
const getCountriesOptions = (lang) => {
    return computeOptions(countriesMap[lang]);
};
exports.getCountriesOptions = getCountriesOptions;
const getCountriesList = (lang) => {
    return countriesMap[lang];
};
exports.getCountriesList = getCountriesList;
const getAvailableCountries = () => {
    return Object.keys(countriesMap);
};
exports.getAvailableCountries = getAvailableCountries;
//# sourceMappingURL=index.js.map